import {
  createRouter,
  createWebHistory,
} from 'vue-router'

import editor from '@/router/editor'
import base from '@/router/base'

import { checkAuth } from '@/hooks/authentication'
import useRouter from '@/helpers/useRouter'
import redirectWebHashRoutes from '@/hooks/redirectWebHashRoutes'

const routes = [
  ...editor,
  ...base,
]

// Create the router
const router = createRouter({
  history: createWebHistory(),
  routes,
})

/**
 * Provide the router to useRouter
 *
 * Router should never be imported directly except in "main.js"
 *
 * When access to the router is needed, "useRouter()" should
 * be called
 */
useRouter(router)

// Check it the path was in WebHashHistory mode to redirect to the matching WebHistory route
router.beforeResolve(redirectWebHashRoutes)

// Check that the token is still valid on route change
router.beforeResolve(checkAuth)

export default router
